import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { Database } from '../../providers/database';
import { ReserveData } from '../../providers/reserve';
import { EventReserveView } from '../event-reserve-view/event-reserve-view';

@Component({
  selector: 'page-event-profile-reserves',
  templateUrl: 'event-profile-reserves.html',
})
export class EventProfileReserves {

  obs: any;
  dataReserves: any;
  client: any;
  event: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, public reserveProvider: ReserveData, public modalCtrl: ModalController) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.obs = this.reserveProvider.getReservesUser(this.client).subscribe((data: any) => {
      console.log(data)
      this.dataReserves = data;
    });
  }

  view(reserve) {
    let modal = this.modalCtrl.create(EventReserveView, {client: this.client, event: this.event, reserveData: reserve});
    modal.present();
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    console.log('Se eliminan los observable de reserves', 'obs');
    if (this.obs) {
      this.obs.unsubscribe();
    }
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-profile-reserves/event-profile-reserves.ts